import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import { Trans, useTranslation } from "react-i18next";
import { createTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import { Title } from '../../../components/Title';
import { IntLink } from '../../../components/IntLink';
import { TextBlack } from '../../../components/TextBlack';

import Image_de from '../../../images/service/private/Privatgarten_DE.png';
import Image_it from '../../../images/service/private/Privatgarten_IT.png';

const GButton = styled(Button)({
  borderRadius: 0,
  color: 'white',
  backgroundColor: '#00652b',
  fontWeight: 'bold',
  fontSize: '16pt',
  textTransform: 'uppercase',
  minWidth: '210px',
  minHeight: '60px',
  '&:hover': {
    backgroundColor: '#00652b',
  },
});

const theme = createTheme({
  typography: {
    gtitle: {
      fontSize: '42pt',
      fontWeight: 600,
      color: '#00652b',
      lineHeight: '42pt',
      '@media (max-width: 992px)': {
        fontSize: '32pt',
      },
    },
    text: {
      fontSize: '16pt',
      color: 'black',
      '@media (max-width: 992px)': {
        fontSize: '16pt',
      },
    }
  },
});


const anchors = document.querySelectorAll('a[href*="#"]')

for (let anchor of anchors) {
  anchor.addEventListener("click", function (event) {
    event.preventDefault();
    const blockID = anchor.getAttribute('href')
    document.querySelector('' + blockID).scrollIntoView({
      behavior: "smooth",
      block: "start"
    })
  })
}

export default function GetPlackette() {

  const { t, i18n } = useTranslation();

  let mailto = "mailto:".concat(t('nig_email'));

  return (


    <>

      <Box id="badge" className='maintextbox' sx={{
        marginTop: 2,
      }}>

        <Title title="how_to_get_badge" variant="title"></Title>


        <Box className='pad' />

        <div className="paragraph">
          <TextBlack text="how_to_get_badge_1_1" para={false}></TextBlack>&nbsp;
          <IntLink link="/private#criterias" text='how_to_get_badge_1_2'></IntLink>&nbsp;
          <TextBlack text="how_to_get_badge_1_3" para={false}></TextBlack>&nbsp;
          <IntLink link="/private#elements" text='how_to_get_badge_1_4'></IntLink>&nbsp;
          <TextBlack text="how_to_get_badge_1_5" para={false}></TextBlack>&nbsp;
          <IntLink link="/private#care" text='how_to_get_badge_1_6'></IntLink>&nbsp;
          <TextBlack text="how_to_get_badge_1_7" para={false}></TextBlack>
        </div>

        <TextBlack text="how_to_get_badge_2"></TextBlack>

        {i18n.language == "de" ?
          <img src={Image_de} className='beratungen-im' alt="de" width='100%' />
          :
          <img src={Image_it} className='beratungen-im' alt="it" width='100%' />
        }

        {/* 
        <Typography className="textbody" variant="text" theme={theme} paragraph={false}>
          <Trans
            i18nKey="how_to_get_badge_3"
            components={{ italic: <i />, strong: <strong /> }}
          />
        </Typography>
        


        <a href="/private#elements">
          <TextBlack text="how_to_get_badge_4"></TextBlack>
        </a>
        */}

        <a href="/private#care">

        </a>

        <Typography variant='text' theme={theme}>
          <Box sx={{ paddingBottom: 2 }} />

          <Box
            sx={{
              color: '#006c38',
            }}>


            <Box sx={{ paddingBottom: 2 }} />
            {t("fill_out_formular")}
            <br />
            {t('or')}
            <br />
            {t("send_email_to")}

            <Link href={mailto} sx={{ color: '#00652b', textDecorationColor: '#00652b', }}>
              {t('nig_email')}
            </Link>

          </Box>
        </Typography>

        <Box sx={{ paddingBottom: 2 }} />

        <GButton variant="contained" size="large" href='#formular' sx={{
          m: 1,

          '&.Mui-checked': {
            color: '#00652b',

          },
          width: '250px',
          height: '60px',
        }}>
          {t("go_to_formular")}
        </GButton>

      </Box>
    </>
  );
}